/**
 * FE-C2g batch-7: Device provision / activate — contract paths.
 */

import { buildContractPath } from "./api/contract-client.js";

export const PROVISION_CONSOLE_TIMEOUT_MS = 20000;

export function buildPostProvisionClaimPath() {
  return buildContractPath("post__provision_claim");
}

export function buildPostProvisionIdentifyPath() {
  return buildContractPath("post__provision_identify");
}
